import {
  AppBar,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { MoreVert } from "@mui/icons-material";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import ChevronLeftSharpIcon from "@mui/icons-material/ChevronLeftSharp";

function Navbar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { pathname } = useLocation();
  const { user, logout, loading } = useAuthContext();
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  const settings = [
    {
      label: "Αποσύνδεση",
      action: () => {
        setAnchorEl(null);
        logout();
      },
    },
  ];

  const linkHoverHome = {
    textDecoration: pathname === "/" ? "underline" : "none",
    textUnderlinePosition: "under",
    color: "inherit",
    "&:hover": {
      textDecoration: "underline",
    },
  };

  return (
    <AppBar
      id="navigation-bar"
      sx={{ zIndex: 10000, height: "80px", width: "100%" }}
      position="sticky"
      color="primary"
    >
      {user ? (
        <Box sx={{ width: "100%", height: "100%", display: "flex" }}>
          <Box sx={{ display: "flex", width: "50%", alignItems: "center" }}>
            <>
              {location.pathname !== "/dashboard" && (
                <Box sx={{ pl: 3 }}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="back"
                    onClick={() => navigate(-1)}
                  >
                    <ChevronLeftSharpIcon />
                  </IconButton>
                </Box>
              )}
              <Box display="flex" sx={{ paddingLeft: "3em" }}>
                <Link
                  to="/dashboard"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography sx={linkHoverHome}>Πίνακας Ελέγχου</Typography>
                </Link>
              </Box>
            </>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mr: 3,
              width: "50%",
              alignItems: "center",
            }}
          >
            <Typography variant="h4" component="div">
              {user}
            </Typography>
            {user && (
              <>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVert style={{ color: "white" }} />
                </IconButton>
                <Menu
                  sx={{ mt: "45px", zIndex: 10000 }}
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting, index) => (
                    <MenuItem key={index} onClick={setting.action}>
                      {setting.label}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            width: "100vw",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">
            Βεβαιώσεις Οφειλών Kεντρικής Ένωσης Επιμελητηρίων Ελλάδος
          </Typography>
        </Box>
      )}
    </AppBar>
  );
}

export default Navbar;
